import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import EffectUtility from "../../utilities/EffectUtility";
import MenuModel from "./models/MenuModel";

export default class MenuEffect {
    public static async menuGet(): Promise<MenuModel[] | HttpErrorResponseModel> {
        const endpoint: string = "";

        return EffectUtility.getToModel<MenuModel[]>(MenuModel, endpoint, { lingua: environment.lang });
    }
}
